var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:{
        'touched': _vm.touched
    },attrs:{"fab":"","id":"record-button"},on:{"mousedown":_vm.handleMouseDown,"mouseup":_vm.handleMouseUp,"touchstart":_vm.handleTouchStart,"touchend":_vm.handleTouchEnd,"touchmove":_vm.handleTouchMove}},'v-btn',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }